"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect, useRef } from "react";

declare global {
  interface Window {
    bluemixAnalytics?: any;
  }
}

export default function AnalyticsTracker() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const isFirstRun = useRef(true);

  useEffect(() => {
    if (!window.bluemixAnalytics) return;

    const url =
      pathname +
      (searchParams?.toString()
        ? `?${searchParams.toString()}`
        : "");

    if (isFirstRun.current) {
      isFirstRun.current = false;
      return;
    }

 
    window.bluemixAnalytics._pushContext({
      page: {
        pageInfo: {
          pageID: url,
          pageName: document.title,
          destinationURL: window.location.href,
        },
      },
    });

    window.bluemixAnalytics.pageEvent();

    console.log("[Bluemix] SPA page view:", url);
  }, [pathname, searchParams]);

  return null;
}